import * as types from "./const";

export const postAddTenantUserRequest = (payload: object) => ({
  type: types.POST_ADD_USER_REQUEST,
  payload,
});
